<template lang="pug">
  article#about(v-once)
    h2 Sobre nóis
    h3 Em breve
</template>

<script>
export default {
  name: 'About'
}
</script>

<style lang="stylus" scoped>

</style>



// WEBPACK FOOTER //
// src/components/About.vue